module.exports = __webpack_public_path__ + "e9c477e8/img/splash-icon.07a7c465.svg";